import { getReviewUserDisplay } from "@components/QaReview/components/commentAuthor";
import { useCanReviewReport } from "@components/ReportReview/hooks/useCanReviewReport";
import { latestRequest } from "@components/ReportReview/reviewers";
import { useReport } from "@providers/ReportProvider";

const useAuthor = () => {
  const { report } = useReport();
  const authorMeta = report.createdBy?.provider?.providermetadata;
  return authorMeta ? { id: authorMeta.id, firstName: authorMeta.firstName, lastName: authorMeta.lastName } : null;
};

/** The report author, who receives a send-back. */
export const useAuthorName = (fallback: string): string => {
  const author = useAuthor();
  return author ? getReviewUserDisplay(author).name : fallback;
};

/** Who asked me to review: the latest requester, then the report author, then the fallback. */
export const useRequesterName = (fallback = "Someone"): string => {
  const myReview = useCanReviewReport();
  const requester = myReview ? latestRequest([myReview])?.actor : undefined;
  const author = useAuthor();
  const source = requester ?? author;
  return source ? getReviewUserDisplay(source).name : fallback;
};
